import { render, staticRenderFns } from "./ReSearchCardService.vue?vue&type=template&id=18dcd34e&scoped=true"
import script from "./ReSearchCardService.vue?vue&type=script&lang=js"
export * from "./ReSearchCardService.vue?vue&type=script&lang=js"
import style0 from "./ReSearchCardService.vue?vue&type=style&index=0&id=18dcd34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dcd34e",
  null
  
)

export default component.exports